import { render, staticRenderFns } from "./PriorityLessee.vue?vue&type=template&id=63262528&scoped=true"
import script from "./PriorityLessee.vue?vue&type=script&lang=js"
export * from "./PriorityLessee.vue?vue&type=script&lang=js"
import style0 from "./PriorityLessee.vue?vue&type=style&index=0&id=63262528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63262528",
  null
  
)

export default component.exports